import { Controller } from 'stimulus';

export default class ImageLoadingController extends Controller {
  connect() {
    this.imageElement = this.element.querySelector('img');
    if (!this.imageElement) return;

    this.setupObserver();
    this.setupImageState();
  }

  setupImageState() {
    this.element.classList.remove('stop-animation');
    this.imageElement.classList.remove('loaded');

    if (this.imageElement.src && this.imageElement.complete) {
      this.onImageLoad();
    } else {
      this.imageElement.addEventListener('load', this.onImageLoad);
      this.imageElement.addEventListener('error', this.onImageError);
    }
  }

  setupObserver() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'src'
        ) {
          this.setupImageState();
        }
      });
    });

    this.observer.observe(this.imageElement, {
      attributes: true,
      attributeFilter: ['src'],
    });
  }

  onImageLoad = () => {
    this.imageElement.classList.add('loaded');
    this.clearAnimation();
    this.cleanupListeners();
  };

  onImageError = () => {
    this.clearAnimation();
    this.cleanupListeners();
  };

  clearAnimation() {
    this.element.classList.add('stop-animation');
  }

  cleanupListeners() {
    if (!this.imageElement) return;

    this.imageElement.removeEventListener('load', this.onImageLoad);
    this.imageElement.removeEventListener('error', this.onImageError);
  }

  disconnect() {
    this.cleanupListeners();
    if (this.observer) this.observer.disconnect();
  }
}
